import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Product = ({ carPart }) => {
  const { _id, img, name, price, description } = carPart;
  const nPrice = parseInt(price);
  let listPrice = 0;
  if (40000 < nPrice) {
    listPrice = nPrice * 0.1 + nPrice;
  } else if (10000 < nPrice) {
    listPrice = nPrice * 0.2 + nPrice;
  } else if (5000 < nPrice) {
    listPrice = nPrice * 0.25 + nPrice;
  } else if (2000 < nPrice) {
    listPrice = nPrice * 0.3 + nPrice;
  } else if (1500 < nPrice) {
    listPrice = nPrice * 0.35 + nPrice;
  } else if (500 < nPrice) {
    listPrice = nPrice * 0.4 + nPrice;
  } else {
    listPrice = nPrice * 0.5 + nPrice;
  }

  const navigate = useNavigate();
  const navigateToPartsDetail = (_id) => {
    navigate(`/product/${_id}`);
  };
  return (
    <div className="card card-compact w-80 mx-auto  border-2 shadow-2xl hover:scale-105 hover:duration-500 bg-neutral rounded-md border-white">
      <figure className="hover:scale-105 hover:duration-500 ">
        <img className="h-80 w-80" src={img} alt="Shoes" />
      </figure>
      <div class="card-body text-accent" style={{ fontFamily: "Roboto" }}>
        <Link to={`/product/${_id}`} className=" text-accent">
          <h2 className="text-sm text-center font-bold text-black">
            {name.slice(0, 70)}..
          </h2>

          <p className="text font-bold text-center text-primary">
            Price: {price} Tk
            <span className="line-through text-gray-400 text-right ml-3">
              list price: {listPrice} Tk
            </span>
          </p>
        </Link>
        <p className="text-center text-accent">{description.slice(0, 75)}..</p>

        <div className="card-actions justify-end">
          <button
            onClick={() => navigateToPartsDetail(_id)}
            className="btn w-full max-w-xs shadow-2xl bg-primary border-white border-2 hover:text-primary text-white"
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default Product;
